module.exports = __webpack_public_path__ + "static/media/5.4a5ac56d.png";